import logo from './logo.svg';
import { RouterProvider } from 'react-router-dom';
import routes from './Components/Routes';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'rsuite/dist/rsuite.min.css';
import './App.css';
import toast, { Toaster } from 'react-hot-toast';
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";

function App() {
  return (
    <>
    <style>
      {
        `body{
          font-family: 'Nunito', sans-serif !important;
        }`
      }
    </style>
      <Toaster position="top-center" reverseOrder={false} />
      <RouterProvider router={routes} />
    </>
  );
}

export default App;
